/** Semantic color tokens — map Figma palettes to Chakra `colorPalette` slots. */
export const semanticColors = {
  bg: {
    DEFAULT: { value: '{colors.neutral.0}' },
  },
  fg: {
    DEFAULT: { value: '{colors.neutral.500}' },
    error: { value: '{colors.red.600}' },
    muted: { value: '{colors.neutral.250}' },
  },
  border: {
    DEFAULT: { value: '{colors.neutral.200}' },
    subtle: { value: '{colors.neutral.100}' },
  },
  blue: {
    solid: { value: '{colors.blue.500}' },
    fg: { value: '{colors.blue.500}' },
    muted: { value: '{colors.blue.500}' },
    subtle: { value: '{colors.blue.50}' },
    border: { value: '{colors.neutral.200}' },
  },
  brand: {
    solid: { value: '{colors.brand.500}' },
    contrast: { value: '{colors.neutral.0}' },
    fg: { value: '{colors.brand.700}' },
    muted: { value: '{colors.brand.50}' },
    subtle: { value: '{colors.brand.100}' },
    emphasized: { value: '{colors.neutral.200}' },
    border: { value: '{colors.neutral.200}' },
    focusRing: { value: '{colors.brand.500}' },
  },
  neonGreen: {
    solid: { value: '{colors.neonGreen.500}' },
    contrast: { value: '{colors.neutral.500}' },
    fg: { value: '{colors.neonGreen.700}' },
    muted: { value: '{colors.neonGreen.50}' },
    subtle: { value: '{colors.neonGreen.100}' },
    emphasized: { value: '{colors.neutral.200}' },
    border: { value: '{colors.neutral.200}' },
    focusRing: { value: '{colors.neonGreen.500}' },
  },
  neutral: {
    solid: { value: '{colors.neutral.100}' },
    contrast: { value: '{colors.neutral.500}' },
    fg: { value: '{colors.neutral.500}' },
    muted: { value: '{colors.neutral.0/10}' },
    subtle: { value: '{colors.neutral.200}' },
    emphasized: { value: '{colors.neutral.200}' },
  },
  green: {
    solid: { value: '{colors.green.500}' },
    fg: { value: '{colors.green.500}' },
    muted: { value: '{colors.green.500}' },
    subtle: { value: '{colors.green.100}' },
  },
  red: {
    solid: { value: '{colors.red.500}' },
    fg: { value: '{colors.red.500}' },
    muted: { value: '{colors.red.500}' },
    subtle: { value: '{colors.red.100}' },
  },
  orange: {
    solid: { value: '{colors.orange.500}' },
    fg: { value: '{colors.orange.500}' },
    muted: { value: '{colors.orange.500}' },
    subtle: { value: '{colors.orange.100}' },
  },
};
